import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Before_footer.scss";
import { Link } from "react-router-dom";
import { IoCallOutline } from "react-icons/io5";
import { getCountryPhoneDetails } from "../../utils/countryUtils";
import gdpr from "../../assets/logo/GDPR.png";
import abdm from "../../assets/logo/ABDM.png";
import hippa from "../../assets/logo/HIPPA.png";
import iso from "../../assets/logo/ISO.png";

const Before_footer = ({
  title,
  description,
  buttonText,
  buttonLink,
  call,
}) => {
  const [phoneDetails, setPhoneDetails] = useState({ number: '', flag: '' });

  // Initialize AOS and get country details
  useEffect(() => {
    const fetchCountryDetails = async () => {
      const details = await getCountryPhoneDetails();
      setPhoneDetails(details);
    };

    fetchCountryDetails();

    AOS.init({
      duration: 1000, // animation duration in ms
      once: true, // whether animation should happen only once
    });
  }, []);

  return (
    <div className="before-footer-parent parent">
      <div className="before-footer-container container">
        <p className="section-ind curious" data-aos="fade-up">
          {title}
        </p>

        <h2 className="heading" data-aos="fade-up" data-aos-delay="200">
          {description}
        </h2>

        {buttonText && buttonLink && !call && (
          <Link
            to={buttonLink}
            className="cta-btn"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            {buttonText}
          </Link>
        )}

        {call && (
          <a
            href={`tel:${phoneDetails.number.replace(/\s/g, '')}`}
            className="cta-btn"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <span>
              <IoCallOutline />
            </span>
            {phoneDetails.number} {phoneDetails.flag}
          </a>
        )}

        <div className="logo-container" data-aos="fade-up" data-aos-delay="300">
          <div className="logo">
            <img src={gdpr} alt="Certification 1" />
          </div>
          <div className="logo">
            <img src={abdm} alt="Certification 2" />
          </div>
          <div className="logo">
            <img src={hippa} alt="Certification 3" />
          </div>
          <div className="logo">
            <img src={iso} alt="Certification 4" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Before_footer;
